import { render, staticRenderFns } from "./CRUDTurnosFuncionarios.vue?vue&type=template&id=54b2d478&"
import script from "./CRUDTurnosFuncionarios.vue?vue&type=script&lang=js&"
export * from "./CRUDTurnosFuncionarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports